import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import './Footer.css';

const Footer = () => {
  const { t } = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-section">
            <h3 className="footer-title">{t('aboutProject')}</h3>
            <p className="footer-description">
              {t('footerDesc')}
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('navigation')}</h3>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">{t('home')}</Link>
              <Link to="/news" className="footer-link">{t('news')}</Link>
              <Link to="/library" className="footer-link">{t('library')}</Link>
              <Link to="/donations" className="footer-link">{t('donations')}</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('info')}</h3>
            <nav className="footer-nav">
              <Link to="/about" className="footer-link">{t('about')}</Link>
              <Link to="/contacts" className="footer-link">{t('contacts')}</Link>
              <Link to="/privacy-policy" className="footer-link">{t('privacyPolicy')}</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('contacts')}</h3>
            <div className="footer-contacts">
              <p>📧 info@kyrgyzaid.kg</p>
              <p>📞 +996 (xxx) xx-xx-xx</p>
              <p>📍 Бишкек, Кыргызстан</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              © Общественный фонд "КыргызЭйд" 2016-{currentYear}. 
              {t('rights')}
            </p>
          </div>
          <div className="footer-legal">
            <Link to="/privacy-policy" className="footer-legal-link">
              {t('privacyPolicy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
